import state from '@/taskpane/state/sidebar-state'
import officeUI from './office-ui'
import officeEwsRequests from './office-ews-requests'
import officeUserProfile from './office-user-profile'
import officeRecipients from './office-recipients'
import officeBody from './office-body'
import officeMail from './office-message'
import officeEvent from './office-events'
import officePlatform from './office-platform'
import officeHandlers from './office-handlers'
import officeMailMode, { officeIsComposeMode } from './office-mail-mode'
import officeAttachments from './office-attachments'
import officeCategories from './office-categories'
import officeCustomProperties from './office-custom-props'
import { officeApiItem_GetItemIdAsync, officeApiItem_SaveAsync } from './async/office-api-mailbox-item-async'
import officeSubject from './office-subject'
import graph from '@/taskpane/graph/graph-wrapper'
import getRestItemId from '@/taskpane/office-rest/office-rest-get-item-id'

export async function officeItemId(): Promise<string> {
  if (officeIsComposeMode()) {
    if (!Office.context.mailbox.item.itemId && !state.currentItem.composeInfo.itemId) {
      state.currentItem.composeInfo.itemId = await officeApiItem_GetItemIdAsync()
    }
    return Office.context.mailbox.item.itemId || state.currentItem.composeInfo.itemId || ''
  } else {
    return Office.context.mailbox.item.itemId || ''
  }
}

export async function officeItemImmutableId(): Promise<string> {
  if (!state.currentItem.composeInfo.immutableId && (await officeItemId()) && graph.isAvailable()) {
    try {
      const restId = getRestItemId(await officeItemId())
      const translatedIds = await graph.translateExchangeIds([restId], 'restId', 'restImmutableEntryId')
      if (translatedIds && translatedIds.length > 0) {
        state.currentItem.composeInfo.immutableId = translatedIds[0]
      }
      return state.currentItem.composeInfo.immutableId
    } catch (error) {
      return null
    }
  } else {
    return state.currentItem.composeInfo.immutableId
  }
}

export async function officeItemSave(): Promise<string> {
  const itemId = await officeApiItem_SaveAsync()

  if (officeIsComposeMode()) {
    state.currentItem.composeInfo.itemId = itemId
  }

  return itemId
}

export function officeItemClose(): void {
  Office.context.mailbox.item.close()
}

const office = {
  id: officeItemId,
  immutableId: officeItemImmutableId,
  save: officeItemSave,
  close: officeItemClose,
  handlers: officeHandlers,
  platform: officePlatform,
  profile: officeUserProfile,
  mode: officeMailMode,
  people: officeRecipients,
  mail: officeMail,
  event: officeEvent,
  body: officeBody,
  subject: officeSubject,
  attachments: officeAttachments,
  categories: officeCategories,
  customProps: officeCustomProperties,
  ews: officeEwsRequests,
  ui: officeUI,
}

export default office
